import Enumerable from "linq";
import { IDocumentEditable } from "..";
import { DesignatedDoctorInformation } from "../../../../domain/user";
import { instanceOfIDesignatedDoctorNumberApplicable, IDesignatedDoctorNumberApplicable, instanceOfITextDrawable } from "../../../../domain/document/items";
import { DateFormatter } from "../../../../domain/system";
import { IConfiguration } from "../../../../domain/configuration";

export class DesignatedDoctorNumberApplicator {
  constructor(public source: IDocumentEditable, private _configuration: IConfiguration) {}
  
  apply(infos: DesignatedDoctorInformation[], userIds: string[]): void {
    if (!infos) { throw new Error("designated doctor information is empty!!!"); }
    const upperUserIds = (userIds && userIds.length) ? userIds.map(u => !!u ? u.toUpperCase() : u) : [];
    const today = new Date();
    const yyyymmdd = DateFormatter.format(today, "YYYYMMDD");
    for (let itemSetId = 0; itemSetId < this.source.itemSets.length; itemSetId++) {
      for (const item of this.source.itemSets[itemSetId].items) {
        if (!instanceOfIDesignatedDoctorNumberApplicable(item) || !item.designatedDoctorNumberType) { continue; }
        const relatedInfos = Enumerable.from(upperUserIds)
          .select(u => this.extractUserDesignatedDoctorInformation(infos, u, item.designatedDoctorNumberType, yyyymmdd))
          .where(i => !!i)
          .toArray();
        const text = this.toDesignatedDoctorNumberText(relatedInfos, this.getCurrentText(item));
        const cloned = item.clone() as IDesignatedDoctorNumberApplicable;
        cloned.setDesignatedDoctorNumber(text);
        cloned.adjustFontSize();
        this.source.updateItem(cloned, {
          itemSetId,
        });
      }
    }
  }

  private getCurrentText(item: IDesignatedDoctorNumberApplicable): string {
    return instanceOfITextDrawable(item)
      ? item.text()
      : null;
  }

  private toDesignatedDoctorNumberText(relatedInfos: DesignatedDoctorInformation[], currentText: string): string {
    const text = !!relatedInfos.length
    ? relatedInfos.map(i => i.doctorNumber).join("・")  // TODO:連結する文字列の指定への対応
    : "";

    return (!text && this._configuration.behavior.document.editor.designatedDoctorNumber.shouldSetWhiteSpaceIfEmpty)
      ? this.createEmptyText(currentText)
      : text;
  }

  private createEmptyText(currentText: string): string {
    // 現在の値と同一だと外部処理がキックされなくてクリアされない場合があるので値を変えている
    return (currentText === " ")
      ? "  "
      : " ";
  }

  /**
   * 期間・種別が重複するデータがある場合は開始日が新しい日付のデータを優先して返却している
   */
  private extractUserDesignatedDoctorInformation(infos: DesignatedDoctorInformation[], userIdAsUpper: string, typeCode: string, today: string): DesignatedDoctorInformation {
    return Enumerable.from(infos)
      .where(i => this.isRelatedUserDesignatedDoctorInformation(i, userIdAsUpper, typeCode, today) && !!i.doctorNumber)
      .orderBy(i => i.startDate)
      .lastOrDefault();
  }

  private isRelatedUserDesignatedDoctorInformation(info: DesignatedDoctorInformation, userIdAsUpper: string, typeCode: string, today: string): boolean {
    return (info.userIdAsUpper === userIdAsUpper)
      && (info.typeCode === typeCode)
      && (info.startDate <= today)
      && (info.endDate >= today);
  }
}
